import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Patient } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';

import { PatientHeaderComponent } from '../../components/patient-header/patient-header.component';
import { PatientCommunicationsComponent } from '../../components/patient-communications/patient-communications.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-patient-communications',
    templateUrl: './capture-admin-patient-communications.component.html',
    styleUrls: ['./capture-admin-patient-communications.component.scss'],
    imports: [PatientHeaderComponent, PatientCommunicationsComponent, MatProgressSpinner]
})
export class CaptureAdminPatientCommunicationsComponent implements OnInit {
  private patientService = inject(PatientService);
  private route = inject(ActivatedRoute);

  patient: Patient;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    const patientId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.loading = true;
    this.patientService.get(patientId).subscribe(patient => {
      this.patient = patient;
      this.loading = false;
    });
  }
}
